(function() {
    "use strict"

    angular.module('formApp')
    .config([
        '$routeProvider', '$locationProvider', '$httpProvider', '$compileProvider', 'digestHudProvider', 'vcRecaptchaServiceProvider', 'adalAuthenticationServiceProvider',
        function ($routeProvider, $locationProvider, $httpProvider, $compileProvider, digestHudProvider, vcRecaptchaServiceProvider, adalAuthenticationServiceProvider) {

            // Re-enable if needed for debugging
            //digestHudProvider.enable();
            $compileProvider.debugInfoEnabled(false);

            adalAuthenticationServiceProvider.init(
                {
                    anonymousEndpoints: __env.AzureADSettings.anonymousEndpoints,
                    instance: __env.AzureADSettings.instance,
                    tenant: __env.AzureADSettings.tenant,
                    clientId: __env.AzureADSettings.clientId,
                    redirectUri: __env.AzureADSettings.redirectUri,
                    popUp: false,
                    scope: 'openid',
                    endpoints: __env.AzureADSettings.endpoints,
                    cacheLocation:
                        'localStorage' // enable this for IE, as sessionStorage does not work for localhost.
                },
                $httpProvider
            );

            if (__env.IsTestRecaptcha)
                vcRecaptchaServiceProvider.setSiteKey(__env.GoogleRecaptchaTestKey);
            else
                vcRecaptchaServiceProvider.setSiteKey(__env.GoogleRecaptchaKey);

            //TODO: Implement Data Service to Check User is Authenticated Or not
            //TODO: Based on Authentication Submit Incident URL will be change

            $routeProvider
                .when('/logout',
                    {
                        resolve: {
                            init: logout
                        }
                    })
                .when('/',
                    {
                        templateUrl: 'app/partials/core/baseLanding.html',
                        controller: 'landingController',
                    })
                .when('/DFFH',
                    {
                        templateUrl: 'app/partials/core/landing.html',
                        controller: 'landingController',
                        resolve: {
                            appStart: appInUse,
                            init: feedbackCheckLoggedIn
                        }
                    })
                .when('/DH',
                    {
                        templateUrl: 'app/partials/core/landing.html',
                        controller: 'landingController',
                        resolve: {
                            appStart: appInUse,
                            init: feedbackCheckLoggedIn
                        }
                    })
                .when('/DFFH/internal',
                    {
                        templateUrl: 'app/partials/core/landing.html',
                        controller: 'landingController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: feedbackCheckLoggedIn
                        }
                    })
                .when('/DH/internal',
                    {
                        templateUrl: 'app/partials/core/landing.html',
                        controller: 'landingController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: feedbackCheckLoggedIn
                        }
                    })
                .when('/DFFH/privacy',
                    {
                        templateUrl: 'app/partials/core/introduction.html',
                        controller: 'introductionController',
                        resolve: {
                            appStart: appInUse,
                            init: privacyCheckLoggedIn
                        }
                    })
                //.when('/DH/privacy',
                //    {
                //        templateUrl: 'app/partials/core/introduction.html',
                //        controller: 'introductionController',
                //        resolve: {
                //            appStart: appInUse,
                //            init: privacyCheckLoggedIn
                //        }
                //    })
                .when('/DFFH/manageFeedbacks',
                    {
                        templateUrl: 'app/partials/dashboard/manageFeedbacks.html',
                        controller: 'manageFeedbacksController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: privacyCheckAccess
                        }
                    })
                .when('/DFFH/manageComplaints',
                    {
                        templateUrl: 'app/partials/dashboard/manageComplaints.html',
                        controller: 'manageComplaintsController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: complaintCheckAccess
                        }
                    })
                .when('/DH/manageFeedbacks',
                    {
                        templateUrl: 'app/partials/dashboard/manageFeedbacks.html',
                        controller: 'manageFeedbacksController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: privacyCheckAccess
                        }
                    })
                .when('/DH/manageComplaints',
                    {
                        templateUrl: 'app/partials/dashboard/manageComplaints.html',
                        controller: 'manageComplaintsController',
                        requireADLogin: true,
                        resolve: {
                            appStart: appInUse,
                            init: complaintCheckAccess
                        }
                    })
                .when('/DFFH/privacyStaffMemberLanding',
                    {
                        templateUrl: 'app/partials/dashboard/staffMemberLanding.html',
                        controller: 'staffMemberLandingController',
                        requireADLogin: true,
                        resolve: {
                            init: appInUse
                        }
                    })
                .when('/DFFH/feedbackStaffMemberLanding',
                    {
                        templateUrl: 'app/partials/dashboard/feedbackStaffMemberLanding.html',
                        controller: 'feedbackStaffMemberLandingController',
                        requireADLogin: true,
                        resolve: {
                            init: appInUse
                        }
                    })
                .when('/DH/feedbackStaffMemberLanding',
                    {
                        templateUrl: 'app/partials/dashboard/feedbackStaffMemberLanding.html',
                        controller: 'feedbackStaffMemberLandingController',
                        requireADLogin: true,
                        resolve: {
                            init: appInUse
                        }
                    })
                .when('/DFFH/tools',
                    {
                        templateUrl: 'app/partials/dashboard/tools.html',
                        controller: 'toolsController',
                        requireADLogin: true,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/tools',
                    {
                        templateUrl: 'app/partials/dashboard/tools.html',
                        controller: 'toolsController',
                        requireADLogin: true,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/incident/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/incident/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/incident/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DH/incident/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DFFH/incidentCoordination/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentCoordinationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/incidentCoordination/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentCoordinationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/incidentCoordination/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentCoordinationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/incidentCoordination/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'incidentCoordinationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/riskAssessment/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'riskAssessmentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/riskAssessment/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'riskAssessmentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/riskAssessment/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'riskAssessmentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/riskAssessment/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'riskAssessmentFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/notification/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'notificationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/notification/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'notificationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/notification/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'notificationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/notification/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'notificationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/investigation/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'investigationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/investigation/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'investigationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/investigation/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'investigationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/investigation/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'investigationFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/practiceImprovement/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'practiceImprovementFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/practiceImprovement/:navTabNum',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'practiceImprovementFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/practiceImprovement/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'practiceImprovementFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/practiceImprovement/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'practiceImprovementFormController',
                        feedbackType: 1,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/complaint/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'complaintFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DH/complaint/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/pageComplaint.html',
                        controller: 'complaintFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DFFH/complaintRegistered/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'complaintRegisteredFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DH/complaintRegistered/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/pageComplaint.html',
                        controller: 'complaintRegisteredFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkOutOfPlaceFormSubmissions
                        }
                    })
                .when('/DFFH/feedbackCoordination/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackCoordinationFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackCoordination/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackCoordinationFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/feedbackAssessment/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackAssessmentFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackAssessment/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackAssessmentFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/feedbackInvestigate/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackInvestigateFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackInvestigate/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackInvestigateFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/feedbackRespond/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackRespondFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackRespond/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackRespondFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/feedbackPracticeImprovement/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackPracticeImprovementFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackPracticeImprovement/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackPracticeImprovementFormController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DFFH/feedbackAdditionalInfo/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackAdditionalInfoController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .when('/DH/feedbackAdditionalInfo/:navTabNum/:pageUrl',
                    {
                        templateUrl: 'app/partials/core/page.html',
                        controller: 'feedbackAdditionalInfoController',
                        feedbackType: 2,
                        resolve: {
                            init: checkDirectNavigation
                        }
                    })
                .otherwise({
                    redirectTo: '/'
                });

            $locationProvider.html5Mode(false).hashPrefix('');
        }
    ])
    .value('departmentTheme', 
    {
        isDHVisible: window.location.hash.indexOf("DH") > -1,
        isDFFHVisible: window.location.hash.indexOf("DFFH") > -1
    })   


    // Push an authenticated user to the management screen for general feedback
    feedbackCheckLoggedIn.$inject = ['$location', 'DataServices', 'Constants', 'UtilityServices'];
    function feedbackCheckLoggedIn($location, DataServices, Constants, UtilityServices) {
        if (DataServices.isAuthenticated()) {
            DataServices.getUserProfileInfoUsingCache()
                .then(function (userInfo) {
                    //$scope.utility = UtilityServices;
                    if (userInfo.isDFFH || userInfo.isSuperAdmin) {
                        if ($location.path().indexOf('DFFH') > -1) {
                            if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                $location.path('/DFFH/manageFeedbacks');
                                                                
                            }
                            else if (DataServices.isRegisteredComplaintsUser(userInfo.roles)) {
                                $location.path('/DFFH/manageComplaints');
                                
                            }
                            else {
                                $location.path('/DFFH/feedbackStaffMemberLanding');
                                
                            }
                        }
                        else if ($location.path().indexOf('DH') > -1) {
                            if (userInfo.isSuperAdmin) {
                                if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                    $location.path('/DH/manageFeedbacks');
                                    
                                }
                                else if (DataServices.isRegisteredComplaintsUser(userInfo.roles)) {
                                    $location.path('/DH/manageComplaints');
                                    
                                }
                                else {
                                    $location.path('/DH/feedbackStaffMemberLanding');
                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else {
                            UtilityServices.invalidUserLogout()                             
                        }
                    }
                    else if (userInfo.isDH || userInfo.isSuperAdmin) {
                        if ($location.path().indexOf('DH') > -1) {
                            if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                $location.path('/DH/manageFeedbacks');
                                
                            }
                            else if (DataServices.isRegisteredComplaintsUser(userInfo.roles)) {
                                $location.path('/DH/manageComplaints');
                                
                            }
                            else {
                                $location.path('/DH/feedbackStaffMemberLanding');
                                
                            }
                        }
                        else if ($location.path().indexOf('DFFH') > -1) {
                            if (userInfo.isSuperAdmin) {
                                if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                    $location.path('/DFFH/manageFeedbacks');
                                    
                                }
                                else if (DataServices.isRegisteredComplaintsUser(userInfo.roles)) {
                                    $location.path('/DFFH/manageComplaints');
                                    
                                }
                                else {
                                    $location.path('/DFFH/feedbackStaffMemberLanding');
                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else {
                            UtilityServices.invalidUserLogout()                             
                        }
                    }
                    else {
                        UtilityServices.invalidUserLogout()                        
                    }
                }, function (data) {
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('/DFFH/feedbackStaffMemberLanding');
                        
                    }
                    else {
                        $location.path('/DH/feedbackStaffMemberLanding');
                        
                    }
                });
        }
    }


    // Push an authenticated user to the management screen for Privacy Incidents
    privacyCheckLoggedIn.$inject = ['$location', 'DataServices', 'Constants', 'UtilityServices'];
    function privacyCheckLoggedIn($location, DataServices, Constants, UtilityServices) {
        if (DataServices.isAuthenticated()) {
            DataServices.getUserProfileInfoUsingCache()
                .then(function (userInfo) {
                    if (userInfo.isDFFH || userInfo.isSuperAdmin) {
                        if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                            $location.path(Constants.Url.manageFeedbacks);
                        }
                        else {
                            $location.path(Constants.Url.privacyStaffMemberLanding);
                        }
                    }
                    else if (userInfo.isDH || userInfo.isSuperAdmin) {
                        if ($location.path().indexOf('DH') > -1) {//
                            if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                $location.path(Constants.Url.manageFeedbacks);
                            }
                        }//
                        else if ($location.path().indexOf('DFFH') > -1) {//
                            if (userInfo.isSuperAdmin) {
                                if (DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                                    $location.path(Constants.Url.manageFeedbacks);
                                }
                                else {
                                    $location.path(Constants.Url.privacyStaffMemberLanding);
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else {
                            UtilityServices.invalidUserLogout()                             
                        }
                    }
                    else {
                        UtilityServices.invalidUserLogout()                        
                    }
                }, function (data) {
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path(Constants.Url.privacyStaffMemberLanding);
                    }
                });
        }
    }


    privacyCheckAccess.$inject = ['$location', 'DataServices', 'Constants', 'UtilityServices'];
    function privacyCheckAccess($location, DataServices, Constants, UtilityServices) {
        if (DataServices.isAuthenticated()) {
            DataServices.getUserProfileInfoUsingCache()
                .then(function (userInfo) {
                    if (!DataServices.isRegisteredPrivacyUser(userInfo.roles)) {
                        if ($location.path().indexOf('DFFH') > -1) {
                            $location.path('/DFFH/privacyStaffMemberLanding');
                            
                        }
                        else {
                            $location.path('/DH/manageComplaints');
                            
                        }
                    }
                    else {
                        if (userInfo.isDFFH || userInfo.isSuperAdmin) {
                            if ($location.path().indexOf('DFFH') > -1) {
                                $location.path(Constants.Url.manageFeedbacks);
                            }
                            else if ($location.path().indexOf('DH') > -1) {
                                if (userInfo.isSuperAdmin) {
                                    $location.path(Constants.Url.manageFeedbacks);
                                }
                                else {
                                    UtilityServices.invalidUserLogout()                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else if (userInfo.isDH || userInfo.isSuperAdmin) {
                            if ($location.path().indexOf('DH') > -1) {
                                $location.path(Constants.Url.manageFeedbacks);
                            }
                            else if ($location.path().indexOf('DFFH') > -1) {
                                if (userInfo.isSuperAdmin) {
                                    $location.path(Constants.Url.manageFeedbacks);
                                }
                                else {
                                    UtilityServices.invalidUserLogout()                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else {
                            UtilityServices.invalidUserLogout()                             
                        }
                    }
                }, function (data) {
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('/DFFH/privacyStaffMemberLanding');
                        
                    }
                });
        }
    }

    complaintCheckAccess.$inject = ['$location', 'DataServices', 'Constants', 'UtilityServices'];
    function complaintCheckAccess($location, DataServices, Constants, UtilityServices) {
        if (DataServices.isAuthenticated()) {
            DataServices.getUserProfileInfoUsingCache()
                .then(function (userInfo) {
                    if (!DataServices.isRegisteredComplaintsUser(userInfo.roles)) {
                        if ($location.path().indexOf('DFFH') > -1) {
                            $location.path('/DFFH/feedbackStaffMemberLanding');
                            
                        }
                        else {
                            $location.path('/DH/feedbackStaffMemberLanding');
                            
                        }
                    }
                    else {
                        if (userInfo.isDFFH || userInfo.isSuperAdmin) {
                            if ($location.path().indexOf('DFFH') > -1) {
                                $location.path(Constants.Url.manageComplaints);
                            }
                            else if ($location.path().indexOf('DH') > -1) {
                                if (userInfo.isSuperAdmin) {
                                    $location.path(Constants.Url.manageComplaints);
                                }
                                else {
                                    UtilityServices.invalidUserLogout()                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else if (userInfo.isDH || userInfo.isSuperAdmin) {
                            if ($location.path().indexOf('DH') > -1) {
                                $location.path(Constants.Url.manageComplaints);
                            }
                            else if ($location.path().indexOf('DFFH') > -1) {
                                if (userInfo.isSuperAdmin) {
                                    $location.path(Constants.Url.manageComplaints);
                                }
                                else {
                                    UtilityServices.invalidUserLogout()                                    
                                }
                            }
                            else {
                                UtilityServices.invalidUserLogout()                                 
                            }
                        }
                        else {
                            UtilityServices.invalidUserLogout()                             
                        }


                    }
                }, function (data) {
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('/DFFH/feedbackStaffMemberLanding');
                        
                    }
                    else {
                        $location.path('/DH/feedbackStaffMemberLanding');
                        
                    }
                });
        }
    }

    logout.$inject = ['adalAuthenticationService'];
    function logout(adalAuthenticationService) {
        if (adalAuthenticationService.userInfo && adalAuthenticationService.userInfo.isAuthenticated) {
            localStorage.clear();
            adalAuthenticationService.logOut();
        }
    }

    // Navigate to a landing page that the user has access to
    function navigateToLandingPage(DataServices, $route, $location, Constants) {

        if (!DataServices.isAuthenticated()) {
            if ($route.current.$$route.feedbackType == 1) {
                $location.path(Constants.Url.privacy);
            }
            else if ($route.current.$$route.feedbackType == 2) {
                $location.path(Constants.Url.internal);
            }
            else {
                $location.path(Constants.Url.landing);
            }
        }
        else if (DataServices.isPartiallyRegisteredUser()) {
            if ($route.current.$$route.feedbackType == 1) {
                $location.path(Constants.Url.privacyStaffMemberLanding);
            }
            else {
                $location.path(Constants.Url.feedbackStaffMemberLanding);
            }
        }
        else {
            if ($route.current.$$route.feedbackType == 1) {
                $location.path(Constants.Url.manageFeedbacks);
            }
            else {
                $location.path(Constants.Url.manageComplaints);
            }
        }
    }

    checkOutOfPlaceFormSubmissions.$inject = ['$route', '$location', 'DataServices', '$rootScope', 'Constants'];
    // this is resolved only on the form submission route
    function checkOutOfPlaceFormSubmissions($route, $location, DataServices, $rootScope, Constants) {
        // once the submissions is successful, we close the submission gateway.
        if ($route.current.params.pageUrl == "submitsuccessful") {
            $rootScope.allowFormNavigation = false;
        }
        else {
            if (!$rootScope.allowFormNavigation) {
                navigateToLandingPage(DataServices, $route, $location, Constants);
            }
        }
    }

    // Track that the app is already in use
    appInUse.$inject = ['$rootScope'];
    function appInUse($rootScope) {
        $rootScope.appJustLoaded = false;
    }

    // Use this resolver when it shouldn't be possible to directly navigate to a certain page.
    // Kick the user to a real landing page if this is the case. Currently prevents problems
    // when the user refreshes a page, e.g. the incident form
    checkDirectNavigation.$inject = ['$route', '$rootScope', '$location', 'DataServices', 'Constants'];
    function checkDirectNavigation($route, $rootScope, $location, DataServices, Constants) {
        if ($rootScope.appJustLoaded) {
            $rootScope.appJustLoaded = false;

            navigateToLandingPage(DataServices, $route, $location, Constants);
        }
    }
}());
